var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-create-client',{attrs:{"selection-disabled":""},on:{"close":function($event){return _vm.$router.go(-1)}}})}
var staticRenderFns = []

export { render, staticRenderFns }